export const enum ActionsTypes {
    LOAD_TEAMS = "availableUsers/LOAD_TEAMS",
    DELETE_TEAM = "availableUsers/DELETE_TEAM",
    CREATE_TEAM = "availableUsers/CREATE_TEAM",
    LOAD_USERS = "availableUsers/LOAD_USERS",
}
